import { ApolloClient, HttpLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client'

declare global {
  interface Window {
    apolloClient?: ApolloClient<NormalizedCacheObject>
  }
}

if(!window.apolloClient){
  window.apolloClient = new ApolloClient({
    link: new HttpLink({
      uri: '/api/2024-01/graphql.json',
      headers: {
        'X-Shopify-Storefront-Access-Token': '8ae6bafd2c75eca211cc01e9a484f133'
      },
      fetchOptions: {
        mode: 'cors',
        credentials: 'include'
      },
    }),
    cache: new InMemoryCache()
  })
}

export const apolloClient = window.apolloClient